module.exports = __webpack_public_path__ + "img/background-side.82f8158b.svg";